import React, { useCallback } from "react";

import FileTag from "@mapmycustomers/shared/types/entity/FileTag";
import { SelectableItem } from "@mapmycustomers/ui";

import styles from "./TagItem.module.scss";

interface Props {
  onClick?: (tag: FileTag) => void;
  selected?: boolean;
  tag: FileTag;
}

const TagItem = ({ onClick, selected, tag }: Props) => {
  const handleClick = useCallback(() => onClick?.(tag), [onClick, tag]);

  return (
    <SelectableItem
      className={styles.container}
      label={tag.name}
      onClick={handleClick}
      selected={selected}
      selectedClassName={styles.selected}
    />
  );
};

export default TagItem;
